import api from '../http/api';
import { post, get } from '../http/http'
import store from '../store/store'
export default {
    returndictLabel(val, index) {
        let name = ""
        let location = JSON.parse(localStorage.getItem("state"));
        // console.log('allDictType', location.allDictType)
        location.allDictType[index].dataList.forEach(item => {
            if (item.dictValue == val) {
                name = item.dictLabel
            }
        });
        return name
    },
    returnRegion(val) {
        let name = ""
        let location = JSON.parse(localStorage.getItem("state"));
        if(location.cityregion){        
            location.cityregion.forEach(item => {
            if (item.id == val) {
                name = item.name
            }
        });
        return name
    }
    },
    returnBussileList(val) {
        // console.log('val', val)
        let name = ""
        let location = JSON.parse(localStorage.getItem("state"));
        location.BussileList.forEach(item => {
            if (item.id == val) {
                name = item.name
            }
        });
        // console.log('name', name)
        return name
    },
    getDictLabel(dictType, dictValue) {
        // 获取本地存储的字典数据
        let allDictType = store.state.allDictType;
        // 封装查找匹配字典的方法
        const findDictLabel = (dictList, dictType, dictValue) => {
            const type = dictList.find((element) => element.dictType === dictType);
            if (type) {
                const val = type.dataList.find((element) => element.dictValue == dictValue);
                return val ? val.dictLabel : dictValue;
            }
            return dictValue;
        };
    
        // 如果本地没有字典数据，或者字典数据为空数组，则从服务端获取
        if (!allDictType.length) {
            return get(api.common.allDictType)
                .then((res) => {
                    if (res.code === 0) {
                        
                        store.commit("updateAllDictType", res.data);
                        return findDictLabel(res.data, dictType, dictValue);
                    }
                    return dictValue;
                })
                .catch((err) => {
                    console.error("获取字典数据失败", err);
                    return dictValue;
                });
        }
    
        // 本地缓存中有字典数据，直接匹配
        return findDictLabel(allDictType, dictType, dictValue);
    },    
    getDictList(dictType) {
        // 获取本地存储的字典数据
        let allDictType = store.state.allDictType;
    
        // 封装查找匹配字典类型的方法
        const findDictList = (dictList, dictType) => {
            const type = dictList.find((element) => element.dictType === dictType);
            return type ? type.dataList : []; // 返回字典类型的数据列表，如果没有找到则返回空数组
        };
    
        // 如果本地没有字典数据，或者字典数据为空数组，则从服务端获取
        if (!allDictType.length) {
            return get(api.common.allDictType)
                .then((res) => {
                    if (res.code === 0) {
                        // 更新存储的字典数据
                        store.commit("updateAllDictType", res.data);
                        return findDictList(res.data, dictType);
                    }
                    return [];
                })
                .catch((err) => {
                    console.error("获取字典数据失败", err);
                    return [];
                });
        }
    
        // 本地缓存中有字典数据，直接匹配
        return findDictList(allDictType, dictType);
    },    
    Dictionaries(dictType) {
        let list = JSON.parse(localStorage.getItem("state")).allDictType.find((element) => (element.dictType === dictType));
        if (list) {
            list.dataList.unshift({
                dictLabel: '不限',
                dictValue: ''
            })
            return list.dataList
        }
    }

} 


// WEBPACK FOOTER //
// ./src/util/commonjs.js